module.exports = __webpack_public_path__ + "static/media/ic_模板_pr.e7d2867d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_模板_pr.svg
// module id = 196
// module chunks = 0